import { Action } from 'redux';

import { View } from './reducers';
import { OpenViewMethod } from './sagas';

export const PUSH_VIEW = 'PUSH_VIEW';
export const POP_VIEW = 'POP_VIEW';
export const REPLACE_VIEW = 'REPLACE_VIEW';
export const SET_ROOT_VIEW = 'SET_ROOT_VIEW';
export const REPLACE_ROOT_AND_CURRENT_VIEW = 'REPLACE_ROOT_AND_CURRENT_VIEW';
export const REQUEST_POP_VIEW = 'REQUEST_POP_VIEW';
export const OPEN_VIEW = 'OPEN_VIEW';

type ViewAction<T> = (view: View, options?: { transient?: boolean; previous?: View }) => T;

export const pushView: ViewAction<Action<typeof PUSH_VIEW> & {
    view: View;
    transient?: boolean;
}> = (view, options = {}) => ({
    type: PUSH_VIEW,
    view,
    transient: options.transient,
});

export const popView = (
    options: { backToViewId?: string } = {},
): Action<typeof POP_VIEW> & { backToViewId?: string } => ({
    type: POP_VIEW,
    backToViewId: options.backToViewId,
});

export const replaceView: ViewAction<Action<typeof REPLACE_VIEW> & {
    view: View;
    transient?: boolean;
}> = (view, options = {}) => ({ type: REPLACE_VIEW, view, transient: options.transient });

export const setRootView: ViewAction<Action<typeof SET_ROOT_VIEW> & { view: View }> = (
    view: View,
) => ({ type: SET_ROOT_VIEW, view });

export const replaceRootAndCurrentView: ViewAction<Action<typeof REPLACE_ROOT_AND_CURRENT_VIEW> & {
    view: View;
    previous?: View;
}> = (view, options = {}) => ({
    type: REPLACE_ROOT_AND_CURRENT_VIEW,
    view,
    previous: options.previous,
});

export const requestPopView = (): Action<typeof REQUEST_POP_VIEW> => ({ type: REQUEST_POP_VIEW });

export const openView = (
    method: OpenViewMethod,
    view: View,
    transient = false,
): Action<typeof OPEN_VIEW> & {
    method: OpenViewMethod;
    view: View;
    transient?: boolean;
} => ({ type: OPEN_VIEW, method, view, transient });
